<template>
  <div class="w-full lg:flex lg:flex-row">
    <div class="w-full mx-auto">
      <div class="w-full px-10 pt-3 pb-3 seccion">
        <div class="w-full seccion">
          <div
            class="flex justify-between py-2 text-xs font-bold border-b border-gray-200"
          >
            <div class="uppercase">{{ $t("Paso 2 de 3") }}</div>
            <div class="text-red-600 red">
              <router-link :to="`/${$i18n.locale}/contenido/condiciones`">
                {{ $t("Leer condiciones") }}
              </router-link>
            </div>
          </div>
        </div>
        <h2 class="text-2xl font-bold tracking-tight text-left">
          {{ $t("Alta comercios") }}
        </h2>
        <!-- <div class="text-left">
        Si tu establecimiento no aparece puedes darte de alta mediante este formulario.
      </div> -->
      </div>
      <div v-if="bonoActual" class="w-full px-10 pt-3 seccion">
        <VForm
          v-if="establecimientoActual"
          class="flex flex-wrap text-left styled"
          @submit.prevent="enviarFormulario"
          novalidate
        >
          <template #default="form">
            <div
              class="w-full px-2 md:w-1/2 xl:w-1/3"
              :class="`${isMultiple[item.campo] ? ' hidden' : ' visible'}`"
              v-for="(item, i) in camposVisibles"
              :key="i"
            >
              <VInput
                v-if="item.visible"
                class="text-xs font-bold uppercase"
                :class="`${
                  item.obligatorio ? ' obligatorio' : 'no-obligatorio'
                }`"
                v-model="establecimientoActual[item.campo]"
                :type="item.tipo"
                :label="$t(item.texto)"
                :name="item.campo"
                :required="item.obligatorio"
                :minlength="item.min"
                :maxlength="item.max"
                :options="item.tipo == 'select' ? listado[item.campo] : []"
                :multiple="
                  isMultiple[item.campo] ? isMultiple[item.campo] : false
                "
              >
                <template #description="input">
                  <template v-if="input.error">
                    <small v-if="input.invalid.required">{{
                      $t("Campo obligatorio")
                    }}</small>
                    <small v-if="input.invalid.minlength">
                      {{ $t("mínimo") }} {{ item.min }} {{ $t("caracteres") }}
                    </small>
                    <small v-if="input.invalid.maxlength">
                      {{ $t("max") }} {{ item.max }} {{ $t("caracteres") }}
                    </small>
                  </template>
                </template>
              </VInput>
            </div>

            <!-- Extra campos -->
            <!-- <div
              class="w-full px-2 md:w-1/2 xl:w-1/3"
              v-for="(item) in camposExtra"
              :key="item.campo"
            >
              <VInput
                v-if="item.visible"
                class="text-xs font-bold uppercase"
                :class="`${item.obligatorio ? ' obligatorio' : 'no-obligatorio'}`"
                v-model="item.valor"
                :type="item.tipo"
                :label="$t(item.texto)"
                :name="item.campo"
                :required="item.obligatorio"
                :minlength="item.min"
                :maxlength="item.max"
                :options="item.tipo=='select' ? listado[item.campo] : [] "
              >
                <template #description="input">
                  <template v-if="input.error">
                    <small v-if="input.invalid.required">{{$t('Campo obligatorio')}}</small>
                    <small v-if="input.invalid.minlength">
                      {{$t('mínimo')}} {{item.min}} {{$t('caracteres')}}
                    </small>
                    <small v-if="input.invalid.maxlength">
                      {{$t('max')}} {{item.max}} {{$t('caracteres')}}
                    </small>
                  </template>
                </template>
              </VInput>
            </div> -->
            <div
              class="hidden w-full px-2 md:w-1/2 xl:w-1/3"
              v-for="item in bonos"
              :key="item.campo"
            >
              <VInput
                v-if="item.visible"
                class="text-xs font-bold uppercase"
                :class="`${
                  item.obligatorio ? ' obligatorio' : ' no-obligatorio'
                }`"
                v-model="establecimientoActual[item.campo]"
                :type="item.tipo"
                :label="$t(item.texto)"
                :name="item.campo"
                :required="item.obligatorio"
                :minlength="item.min"
                :maxlength="item.max"
                :options="item.tipo == 'select' ? listado[item.campo] : []"
                :multiple="
                  isMultiple[item.campo] ? isMultiple[item.campo] : false
                "
              >
                <template #description="input">
                  <template v-if="input.error">
                    <small v-if="input.invalid.required">{{
                      $t("Campo obligatorio")
                    }}</small>
                    <small v-if="input.invalid.minlength">
                      {{ $t("mínimo") }} {{ item.min }} {{ $t("caracteres") }}
                    </small>
                    <small v-if="input.invalid.maxlength">
                      {{ $t("max") }} {{ item.max }} {{ $t("caracteres") }}
                    </small>
                  </template>
                </template>
              </VInput>
            </div>

            <!-- MULti select  -->
            <div class="w-full px-2 py-2">
              <div class="text-xs font-bold uppercase obligatorio">
                <span class="vts-input__text"> {{ $t("IAE") }} </span>
              </div>
              <multiselect
                v-model="IAE"
                name="IAE"
                :options="listado.IAE"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="false"
                selectLabel="+"
                deselectLabel="-"
                selectedLabel=""
                @select="accionCambio('IAE')"
                @remove="accionCambio('IAE')"
                placeholder=""
                label="label"
                track-by="value"
              >
                <span slot="noResult">--</span>
              </multiselect>
            </div>

            <div class="w-full px-2 py-2">
              <div class="text-xs font-bold uppercase obligatorio">
                <span class="vts-input__text">
                  {{ $t("Sector de actividad") }}
                </span>
              </div>
              <multiselect
                v-model="SectorActividad"
                name="SectorActividad"
                :options="listado.SectorActividad"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="false"
                selectLabel="+"
                deselectLabel="-"
                selectedLabel=""
                @select="accionCambio('SectorActividad')"
                @remove="accionCambio('SectorActividad')"
                placeholder=""
                label="label"
                track-by="value"
              >
                <span slot="noResult">--</span>
              </multiselect>
            </div>

            <div class="w-full px-2 py-2">
              <div class="text-xs font-bold uppercase obligatorio">
                <span class="vts-input__text"> {{ $t("Tipo de Bonos") }} </span>
              </div>
              <multiselect
                v-model="TipoBono"
                name="TipoBono"
                :options="listado.TipoBono"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="false"
                selectLabel="+"
                deselectLabel="-"
                selectedLabel=""
                @select="accionCambio('TipoBono')"
                @remove="accionCambio('TipoBono')"
                placeholder=""
                label="label"
                track-by="value"
              >
                <span slot="noResult">--</span>
              </multiselect>
            </div>

            <!-- Imagenes -->
            <div class="flex flex-wrap w-full mt-5 -mx-3">
              <div class="w-1/2 px-3">
                <VDialog
                  v-model="ventanaComercio"
                  transition="slide-right"
                  bg-transition="fade"
                  :classes="{ bg: 'bg-blue-900', content: 'bg-gray-200' }"
                >
                  <template #toggle="{ bind, on }">
                    <button
                      class="w-full h-20 px-3 py-5 text-sm bg-gray-200 bold hover:bg-gray-400"
                      v-bind="bind"
                      v-on="on"
                    >
                      {{ $t("Adjuntar imagen comercio") }}
                    </button>
                  </template>
                  <div class="w-full p-5">
                    <div class="text-base font-semibold text-blue-900">
                      {{ $t("Adjuntar imagen comercio") }}
                    </div>
                    <div class="text-xs">
                      {{ $t("500x500 pixeles (max 600K)") }}
                    </div>
                    <div class="max-w-sm">
                      <subir-imagen
                        carpeta="establecimientos/bizkaia"
                        tipo="imagen-comercio"
                        :imageId="Id"
                        nombre="UrlImagen"
                        accept="image/jpg,image/png"
                        :max="1250000"
                        ventana="ventanaComercio"
                        @accion="log"
                        @cerrar="cerrarVentana"
                      >
                      </subir-imagen>
                    </div>
                    <div class="w-full my-3">
                      <button
                        class="text-sm"
                        @click.prevent="ventanaComercio = !ventanaComercio"
                      >
                        {{ $t("Cerrar") }}
                      </button>
                    </div>
                  </div>
                </VDialog>
                <div class="px-2 imagenes">
                  <div class="text-xs">
                    <div class="text-red-700 bold" v-if="!UrlImagen">
                      {{ $t("falta imagen") }}
                    </div>
                    <div class="text-green-500" v-else>
                      {{ $t("imagen subida correctamente") }}
                    </div>
                  </div>
                  <VInput
                    class="text-xs font-bold uppercase opacity-0"
                    v-model="establecimientoActual['UrlImagen']"
                    type="text"
                    label="url"
                    name="UrlImagen"
                    minlength="2"
                  >
                    <template #description="input">
                      <template v-if="input.error">
                        <small v-if="input.invalid.required">{{
                          $t("Campo obligatorio")
                        }}</small>
                        <small v-if="input.invalid.minlength">
                          {{ $t("mínimo") }} {{ item.min }}
                          {{ $t("caracteres") }}
                        </small>
                      </template>
                    </template>
                  </VInput>
                </div>
              </div>
              <div class="hidden w-1/2 px-3">
                <VDrawer
                  v-model="ventanaRepresentante"
                  transition="slide-right"
                  bg-transition="fade"
                  :classes="{ bg: 'bg-blue-900', content: 'bg-gray-200' }"
                >
                  <template #toggle="{ bind, on }">
                    <button
                      class="w-full h-20 px-3 py-5 text-sm bg-gray-200 bold hover:bg-gray-400"
                      v-bind="bind"
                      v-on="on"
                    >
                      {{ $t("Fotocopia DNI Representante legal") }}
                    </button>
                  </template>
                  <div class="w-full p-5">
                    <div class="text-base font-semibold text-blue-900">
                      {{ $t("Fotocopia DNI Representante legal") }}
                    </div>
                    <div class="text-xs">(max 2M)</div>
                    <upload-imagen
                      carpeta="establecimientos/berriz"
                      tipo="imagen-dni"
                      :imageId="Id"
                      nombre="UrlDni"
                      accept="*"
                      :max="6650000"
                      ventana="ventanaRepresentante"
                      @cerrar="cerrarVentana"
                    ></upload-imagen>
                    <div class="w-full my-3">
                      <button
                        class="text-sm"
                        @click.prevent="
                          ventanaRepresentante = !ventanaRepresentante
                        "
                      >
                        {{ $t("Cerrar") }}
                      </button>
                    </div>
                  </div>
                </VDrawer>
                <div class="px-2 imagenes">
                  <div class="text-xs">
                    <div class="text-red-700 bold" v-if="!UrlDni">
                      {{ $t("falta imagen") }}
                    </div>
                    <div class="text-green-500" v-else>
                      {{ $t("imagen subida correctamente") }}
                    </div>
                  </div>
                  <VInput
                    class="text-xs font-bold uppercase opacity-0"
                    v-model="establecimientoActual['UrlDni']"
                    type="text"
                    label="url dni"
                    name="UrlDni"
                    minlength="2"
                  >
                    <template #description="input">
                      <template v-if="input.error">
                        <small v-if="input.invalid.required">{{
                          $t("Campo obligatorio")
                        }}</small>
                        <small v-if="input.invalid.minlength">
                          {{ $t("mínimo") }} {{ item.min }}
                          {{ $t("caracteres") }}
                        </small>
                      </template>
                    </template>
                  </VInput>
                </div>
              </div>
              <div class="hidden w-1/2 px-3 py-6">
                <VDrawer
                  v-model="ventanaCertificado"
                  transition="slide-right"
                  bg-transition="fade"
                  :classes="{ bg: 'bg-blue-900', content: 'bg-gray-200' }"
                >
                  <template #toggle="{ bind, on }">
                    <button
                      class="w-full h-20 px-3 py-5 text-sm bg-gray-200 bold hover:bg-gray-400"
                      v-bind="bind"
                      v-on="on"
                    >
                      {{
                        $t("Adjuntar certificado titularidad de cuenta (pdf)")
                      }}
                    </button>
                  </template>
                  <div class="w-full p-5">
                    <div class="text-base font-semibold text-blue-900">
                      {{
                        $t("Adjuntar certificado titularidad de cuenta (pdf)")
                      }}
                    </div>
                    <div class="text-xs">(max 3M)</div>
                    <upload-imagen
                      carpeta="establecimientos/berriz"
                      tipo="imagen-certificado"
                      :imageId="Id"
                      nombre="UrlCertificado"
                      accept="*"
                      :max="6650000"
                      ventana="ventanaCertificado"
                      @cerrar="cerrarVentana"
                    ></upload-imagen>
                    <div class="w-full my-3">
                      <button
                        class="text-sm"
                        @click.prevent="
                          ventanaCertificado = !ventanaCertificado
                        "
                      >
                        {{ $t("Cerrar") }}
                      </button>
                    </div>
                  </div>
                </VDrawer>
                <div class="px-2 imagenes">
                  <div class="text-xs">
                    <div class="text-red-700 bold" v-if="!UrlCertificado">
                      {{ $t("falta imagen") }}
                    </div>
                    <div class="text-green-500" v-else>
                      {{ $t("imagen subida correctamente") }}
                    </div>
                  </div>
                  <VInput
                    class="text-xs font-bold uppercase opacity-0"
                    v-model="establecimientoActual['UrlCertificado']"
                    type="text"
                    label="url"
                    name="UrlCertificado"
                    minlength="2"
                  >
                    <template #description="input">
                      <template v-if="input.error">
                        <small v-if="input.invalid.required">{{
                          $t("Campo obligatorio")
                        }}</small>
                        <small v-if="input.invalid.minlength">
                          {{ $t("mínimo") }} {{ item.min }}
                          {{ $t("caracteres") }}
                        </small>
                      </template>
                    </template>
                  </VInput>
                </div>
              </div>
              <div class="w-1/2 px-3">
                <VDrawer
                  v-model="ventanaIAE"
                  transition="slide-right"
                  bg-transition="fade"
                  :classes="{ bg: 'bg-blue-900', content: 'bg-gray-200' }"
                >
                  <template #toggle="{ bind, on }">
                    <button
                      class="w-full h-20 px-3 py-5 text-sm bg-gray-200 bold hover:bg-gray-400"
                      v-bind="bind"
                      v-on="on"
                    >
                      {{ $t("Adjuntar tarjeta IAE") }}
                    </button>
                  </template>
                  <div class="w-full p-5">
                    <div class="text-base font-semibold text-blue-900">
                      {{ $t("Adjuntar tarjeta IAE") }}
                    </div>
                    <div class="text-xs">(max 2M)</div>
                    <upload-imagen
                      carpeta="establecimientos/berriz"
                      tipo="fichero-iae"
                      :imageId="Id"
                      nombre="UrlIAE"
                      accept="*"
                      :max="6650000"
                      ventana="ventanaIAE"
                      @cerrar="cerrarVentana"
                    ></upload-imagen>
                    <div class="w-full my-3">
                      <button
                        class="text-sm"
                        @click.prevent="ventanaIAE = !ventanaIAE"
                      >
                        {{ $t("Cerrar") }}
                      </button>
                    </div>
                  </div>
                </VDrawer>
                <div class="px-2 imagenes">
                  <div class="text-xs">
                    <div class="text-red-700 bold" v-if="!UrlIAE">
                      {{ $t("falta imagen") }}
                    </div>
                    <div class="text-green-500" v-else>
                      {{ $t("imagen subida correctamente") }}
                    </div>
                  </div>
                  <VInput
                    class="text-xs font-bold uppercase opacity-0"
                    v-model="establecimientoActual['UrlIAE']"
                    type="text"
                    label="url"
                    name="UrlIAE"
                    minlength="2"
                  >
                    <template #description="input">
                      <template v-if="input.error">
                        <small v-if="input.invalid.required">{{
                          $t("Campo obligatorio")
                        }}</small>
                        <small v-if="input.invalid.minlength">
                          {{ $t("mínimo") }} {{ item.min }}
                          {{ $t("caracteres") }}
                        </small>
                      </template>
                    </template>
                  </VInput>
                </div>
              </div>
            </div>

            <!-- fin imagenes     -->
            <div v-if="conImagenes && validador < 1" class="w-full">
              <div
                v-html="$t('declaración responsable')"
                class="w-full p-5 text-xs bg-gray-100"
              ></div>
            </div>
            <div v-if="establecimientoActual.EMail">
              <div v-if="!emailCorrecto" class="text-center">
                {{ $t("Verificar e-mail") }}
              </div>
              <div v-else>
                <div v-if="establecimientoActual.IBAN">
                  <div
                    v-if="!IBANCorrecto(establecimientoActual.IBAN)"
                    class="text-center"
                  >
                    {{ $t("iban incorrecto") }}
                  </div>
                  <div v-else>
                    <div v-if="conImagenes" class="my-3 condiciones">
                      <v-input
                        v-model="Aceptar"
                        class="flex text-xs font-thin"
                        :label="$t('Acepto Condiciones')"
                        name="checkbox"
                        type="checkbox"
                        required
                      >
                        <template #description="input">
                          <template v-if="input.error">
                            <small v-if="input.invalid.required">{{
                              $t("Acepta Condicinoes")
                            }}</small>
                          </template>
                        </template>
                      </v-input>
                      <div class="mt-2 text-xs text-right text-red-700">
                        <router-link
                          :to="`/${$i18n.locale}/contenido/condiciones`"
                        >
                          {{ $t("Leer condiciones") }}
                        </router-link>
                      </div>
                    </div>
                    <div
                      class="w-full text-center text-bold tesx-sm"
                      v-if="mensaje"
                    >
                      <div>
                        {{ $t(mensaje) }}
                      </div>
                    </div>
                    <div></div>
                    <div
                      v-if="conImagenes && validador < 1"
                      class="w-full py-4 mb-10 seccion"
                    >
                      <button
                        v-if="$t('activar_altas') == 'S'"
                        :disabled="!Aceptar"
                        :class="`${
                          !Aceptar
                            ? 'bg-gray-300'
                            : 'bg-green-600 hover:bg-green-700'
                        }`"
                        class="block w-full my-3 font-bold text-white uppercase"
                        type="submit"
                      >
                        {{ $t("Enviar") }}
                      </button>
                    </div>
                    <div class="text-xs text-center" v-else>
                      {{ $t("Completar formulario") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </VForm>

        <div class="w-full my-5 text-xs font-thin text-red-600">
          <p v-for="v in camposVisibles" :key="v.campo">
            <span v-if="!establecimientoActual[v.campo]">
              {{ $t(v.texto) }}
            </span>
          </p>
          <p v-for="(v, i) in validador2" :key="i">
            <span>
              {{ $t(v.texto) }}
            </span>
          </p>
        </div>

        <div class="w-full h-64 bg-white" ref="mapa"></div>

        <div v-if="conDireccion" class="w-full px-2 py-5">
          <div v-for="item in establecimientosGoogle" :key="item.plac_id">
            <div class="flex items-baseline h-20">
              <img :src="item.icon" :alt="item.name" class="w-3 h-3 mr-2" />

              <div>
                {{ item.name }}
              </div>
            </div>
          </div>

          <!-- <div class="w-full">
            <div v-html="$t('declaración responsable')" class="w-full p-5 text-xs bg-gray-100">

            </div>
        </div> -->
          <!-- <pre>
      {{establecimientosGoogle}} {{conDireccion}}
    </pre> -->
        </div>

        <div class="w-full py-5 text-base lg:text-sm">
          <h3 class="font-bold">
            {{ $t("Consultas") }}
          </h3>
          <p>{{ $t("email") }}: {{ $t("correo@contacto") }}</p>

          <p>{{ $t("teléfono") }} {{ $t("telefono@contacto") }}</p>

          <!-- <p>
            <a href="tel:946824584">
              {{$t('teléfono')}}: 946 824 584
            </a>
            
          </p> -->
          <!-- <p>
            <a href="tel:945776858">
              {{$t('teléfono')}}: 945 06 43 53
            </a>
            
          </p>
                    <p>
            <a href="tel:945776858">
              {{$t('teléfono')}}: 945 06 43 63
            </a>
            
          </p> -->
        </div>
      </div>
    </div>
    <!-- <div
      :style="`background-image: url('/fondo_${$i18n.locale}.jpg')`"
      class="flex flex-grow w-1/2 h-auto min-h-screen bg-center bg-no-repeat bg-contain lg:block"
    >
 
    </div> -->
  </div>
</template>

<script>
import { VForm, VInput, VDrawer, VDialog } from "vuetensils/src/components";
import {
  SectorActividad_es,
  SectorActividad_eu,
  Municipios,
  IAE_ES,
  IAE_EU,
  Bonos_es,
  Bonos_eu,
  IAE_TURISMO,
  IAE_TURISMO_EU,
} from "@/assets/datos.json";
import Multiselect from "vue-multiselect";
import uploadImagen from "@/components/core/Uploader.vue";
import SubirImagen from "@/components/Cropper";
// GoogleMaps
import gmapsInit from "@/config/pro/gmaps";
import slugify from "slugify";

function fn_ValidateIBAN(IBAN) {
  //Se pasa a Mayusculas
  IBAN = IBAN.toUpperCase();
  //Se quita los blancos de principio y final.
  IBAN = IBAN.trim();
  IBAN = IBAN.replace(/\s/g, ""); //Y se quita los espacios en blanco dentro de la cadena

  var letra1, letra2, num1, num2;
  var isbanaux;
  var numeroSustitucion;
  //La longitud debe ser siempre de 24 caracteres
  if (IBAN.length != 24) {
    return false;
  }

  // Se coge las primeras dos letras y se pasan a números
  letra1 = IBAN.substring(0, 1);
  letra2 = IBAN.substring(1, 2);
  num1 = getnumIBAN(letra1);
  num2 = getnumIBAN(letra2);
  //Se sustituye las letras por números.
  isbanaux = String(num1) + String(num2) + IBAN.substring(2);
  // Se mueve los 6 primeros caracteres al final de la cadena.
  isbanaux = isbanaux.substring(6) + isbanaux.substring(0, 6);

  //Se calcula el resto, llamando a la función modulo97, definida más abajo
  var resto = modulo97(isbanaux);
  if (resto == 1) {
    return true;
  } else {
    return false;
  }
}

function modulo97(iban) {
  var parts = Math.ceil(iban.length / 7);
  var remainer = "";

  for (var i = 1; i <= parts; i++) {
    remainer = String(parseFloat(remainer + iban.substr((i - 1) * 7, 7)) % 97);
  }

  return remainer;
}

function getnumIBAN(letra) {
  const ls_letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  return ls_letras.search(letra) + 10;
}

export default {
  components: {
    VForm,
    VInput,
    uploadImagen,
    VDrawer,
    VDialog,
    SubirImagen,
    Multiselect,
  },
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    this.mensaje = "";
    this.Aceptar = false;
    console.log("montado", this.establecimientoActual);
  },
  data() {
    return {
      mensaje: "",
      miProvincia: "Álava",
      ventanaComercio: false,
      ventanaRepresentante: false,
      ventanaCertificado: false,
      emailVerificado: "",
      ventanaIAE: false,
      establecimientosGoogle: [],
      isMultiple: {
        SectorActividad: true,
        IAE: true,
        TipoBono: true,
      },
      camposMultiples: [
        {
          texto: "Sector de actividad",
          campo: "SectorActividad",
          tipo: "select",
          obligatorio: false,
          visible: true,
          min: "1",
        },
        {
          texto: "IAE",
          campo: "IAE",
          tipo: "select",
          obligatorio: false,
          visible: true,
          min: "1",
        },
        {
          texto: "Tipo de Bonos",
          campo: "TipoBono",
          tipo: "select",
          obligatorio: false,
          visible: true,
          min: "1",
        },
      ],

      Aceptar: false,
      camposExtra: [
        {
          campo: "campo_extra_1",
          max: "100",
          min: "2",
          obligatorio: true,
          texto: "Representante Legal",
          tipo: "text",
          visible: true,
        },
        {
          campo: "campo_extra_2",
          max: "50",
          min: "2",
          obligatorio: true,
          texto: "DNI Representante Legal",
          tipo: "text",
          visible: true,
        },
      ],
      bonos: [
        {
          texto: "Tipo de Bonos",
          campo: "TipoBono",
          tipo: "select",
          max: "160",
          obligatorio: true,
          visible: true,
          min: "2",
        },
      ],
      imagenes: [
        {
          texto: "Imagen comercio",
          campo: "UrlImagen",
          tipo: "text",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Representante",
          campo: "UrlDni",
          tipo: "text",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Imagen Certificado",
          campo: "UrlCertificado",
          tipo: "text",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Imagen IAE",
          campo: "UrlIAE",
          tipo: "text",
          obligatorio: true,
          min: "2",
        },
      ],
      formulario: [
        {
          texto: "Razón Social del establecimiento",
          campo: "RazonSocial",
          tipo: "text",
          max: "60",
          obligatorio: true,
          min: "2",
        },

        {
          texto: "Nombre Comercial",
          campo: "Nombre",
          tipo: "text",
          max: "60",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Sector de actividad",
          campo: "SectorActividad",
          tipo: "select",
          max: "60",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Breve descripción",
          campo: "Descripcion",
          tipo: "text",
          max: "128",
          obligatorio: true,
          min: "25",
        },
        {
          texto: "Nº de personas empleadas (incluído presonal autónomo)",
          campo: "NumeroEmpleados",
          tipo: "select",
          obligatorio: false,
          min: "1",
          max: "24",
        },
        {
          texto: "IAE",
          campo: "IAE",
          tipo: "select",
          obligatorio: false,
          min: "1",
        },
        {
          texto: "NIF/CIF",
          campo: "CIF",
          tipo: "text",
          obligatorio: true,
          min: "6",
          max: "60",
        },

        {
          texto: "Dirección",
          campo: "Direccion",
          tipo: "text",
          max: "120",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Código Postal",
          campo: "CP",
          tipo: "select",
          obligatorio: true,
          min: "5",
          max: "5",
        },
        {
          texto: "Municipio",
          campo: "Poblacion",
          tipo: "select",
          obligatorio: true,
          min: "9",
        },
        {
          texto: "Provincia",
          campo: "Provincia",
          tipo: "select",
          obligatorio: true,
          visible: true,
          min: "3",
        },
        {
          texto: "Persona de contacto",
          campo: "PersonaContacto",
          tipo: "text",
          obligatorio: true,
          max: "60",
          min: "2",
        },

        {
          texto: "Cargo",
          campo: "Cargo",
          tipo: "text",
          max: "60",
          obligatorio: true,
          min: "3",
        },
        {
          texto: "E-mail",
          campo: "EMail",
          tipo: "email",
          max: "60",
          obligatorio: true,
          min: "2",
        },
        {
          texto: "Verificar e-mail",
          campo: "VerifyEMail",
          tipo: "email",
          obligatorio: true,
        },
        {
          texto: "Teléfono",
          campo: "Telefono",
          tipo: "text",
          max: "60",
          obligatorio: true,
          min: "9",
        },

        {
          texto: "Página web",
          campo: "Web",
          tipo: "text",
          max: "180",
          obligatorio: false,
        },
        {
          texto: "Asociaciones de comerciantes a las que pertenece",
          campo: "NombreAsociacion",
          tipo: "text",
          max: "60",
          obligatorio: false,
          min: "5",
        },
        {
          texto: "IBAN",
          campo: "IBAN",
          tipo: "text",
          obligatorio: true,
          min: "24",
          max: "24",
        },
      ],
    };
  },
  // Nombre, Descripcion, Contacto, CIF, Telefono, IdGoogle, EMail, IBAN, DireccionGoogle, Lat, Lng, UrlImagen, Direccion, CP, Provincia, Poblacion, Pais

  computed: {
    SectorActividad: {
      get() {
        return this.$store.state.SectorActividad;
      },
      set(valor) {
        this.$store.commit("SectorActividad", valor);
      },
    },
    IAE: {
      get() {
        return this.$store.state.IAE;
      },
      set(valor) {
        this.$store.commit("IAE", valor);
      },
    },
    TipoBono: {
      get() {
        return this.$store.state.TipoBono;
      },
      set(valor) {
        this.$store.commit("TipoBono", valor);
      },
    },
    conDireccion() {
      let conDireccion = false;
      if (
        this.establecimientoActual.Nombre.length > 3 &&
        this.establecimientoActual.Direccion.length > 3
      ) {
        conDireccion = true;
        this.checkDireccion(this.establecimientoActual);
      }

      return conDireccion;
    },
    camposVisibles() {
      return this.formulario.filter((e) => e.visible);
    },
    bonoActual() {
      const bonoActual = this.$store.state.bonoActual;
      this.formulario = !bonoActual.formulario ? [] : bonoActual.formulario;
      this.imagenes = !bonoActual.imagenes ? [] : bonoActual.imagenes;
      return bonoActual;
    },
    emailCorrecto() {
      if (
        this.establecimientoActual.EMail ==
        this.establecimientoActual.VerifyEMail
      ) {
        return true;
      } else {
        return false;
      }
    },
    conImagenes() {
      // this.UrlImagen &&
      const host = window.location.hostname;
      if (this.UrlImagen && this.UrlIAE) {
        return true;
      } else {
        return host == "localhost" ? true : false;
      }
    },
    validador() {
      let valido = false;
      const validados = {};
      const obligatorios = this.formulario.filter(
        (e) => e.visible == true && e.obligatorio == true
      );
      const todos = obligatorios.filter(
        (e) => !this.establecimientoActual[e.campo]
      );

      console.log("todos", todos);

      return todos;
    },
    validador2() {
      return this.camposMultiples.filter((e) => this[e.campo].length < 1);
    },
    establecimientoActual: {
      get() {
        return this.$store.state.establecimientoActual;
      },
      set(valor) {
        this.$store.commit("establecimientoActual", valor);
      },
    },
    UrlImagen: {
      get() {
        return this.$store.state.UrlImagen;
      },
      set(valor) {
        this.$store.commit("UrlImagen", valor);
      },
    },
    UrlDni: {
      get() {
        return this.$store.state.UrlDni;
      },
      set(valor) {
        this.$store.commit("UrlDni", valor);
      },
    },
    UrlCertificado: {
      get() {
        return this.$store.state.UrlCertificado;
      },
      set(valor) {
        this.$store.commit("UrlCertificado", valor);
      },
    },
    UrlIAE: {
      get() {
        return this.$store.state.UrlIAE;
      },
      set(valor) {
        this.$store.commit("UrlIAE", valor);
      },
    },
    listado() {
      const bono = this.$store.state.bonoName;
      /// console.log('bono actual', bono)
      const IAE = this.$i18n.locale == "es" ? IAE_TURISMO : IAE_TURISMO_EU;
      const SectorActividad =
        this.$i18n.locale == "eu" ? SectorActividad_eu : SectorActividad_es;
      const Bonos = this.$i18n.locale == "eu" ? Bonos_eu : Bonos_es;
      const miMunicipio = Municipios[bono];
      const NumeroEmpleados = [
        {
          value: "",
        },
        {
          value: 1,
        },
        {
          value: 2,
        },
        {
          value: 3,
        },
        {
          value: 4,
        },
        {
          value: 5,
        },
        {
          value: 6,
        },
        {
          value: 7,
        },
        {
          value: 8,
        },
        {
          value: 9,
        },
        {
          value: 10,
        },
      ];
      const ORIGEN = this.$store.state.idOrigen;
      const id_CAMPANA = this.$store.state.idCampana;
      const misBonos = Bonos.map((e) => {
        return {
          ORIGEN,
          id_CAMPANA,
          ...e,
        };
      });
      const listado = {
        Poblacion: miMunicipio,
        IAE: IAE,
        NumeroEmpleados,
        SectorActividad,
        TipoBono: misBonos,
      };
      return listado;
    },
    Id() {
      let random = Math.random().toString(36).substring(2);
      return random.toUpperCase();
    },
  },
  methods: {
    async enviarFormulario({ target }) {
      const form = new FormData(target);
      const data = Object.fromEntries(form);

      const slug = slugify(data.Nombre, {
        lower: true,
        remove: /[*+~.·?¿^()/'"!:@]/g,
      });

      Object.keys(data).forEach((campo) => {
        if (typeof data[campo] === "string") {
          data[campo] = data[campo]
            .replace(/&/g, "&amp;")
            .replace(/>/g, "&gt;")
            .replace(/</g, "&lt;")
            .replace(/"/g, "&quot;");
        } else {
          console.log("mirame no string", objeto[campo]);
        }
      });

      let campanas = "";
      let iaes = "";
      let sectores = "";
      let bonos = "";
      const idCampana = this.$store.state.idCampana;
      campanas = `${idCampana};`;
      // const idBono = this.$store.state.idBono
      this.TipoBono.forEach(
        (e, i) =>
          (campanas += `${e.value}${i < this.TipoBono.length - 1 ? "," : ""}`)
      );
      this.IAE.forEach(
        (e, i) => (iaes += `${e.value}${i < this.IAE.length - 1 ? "," : ""}`)
      );
      this.SectorActividad.forEach(
        (e, i) =>
          (sectores += `${e.value}${
            i < this.SectorActividad.length - 1 ? "," : ""
          }`)
      );
      this.TipoBono.forEach(
        (e, i) =>
          (bonos += `${e.value}${i < this.TipoBono.length - 1 ? "," : ""}`)
      );

      //  console.log('Campaña', campanas, 'iaes', iaes, 'sectores', sectores, 'tipobono', this.TipoBono,'iae', this.IAE, 'data', data)
      const IdOrigenRef = this.$store.state.idOrigen;
      const CIFRef =
        this.establecimientoActual.CIF.length > 1
          ? this.establecimientoActual.CIF
          : "1";
      const IdRef = this.Id;
      const campanasRef = campanas;
      const sectoresRef = sectores;
      const idBarrioRef = !this.establecimientoActual.IdBarrio
        ? ""
        : this.establecimientoActual.IdBarrio;
      const iaeRef = iaes;
      const bonosRef = bonos;
      const Web = !this.establecimientoActual.Web
        ? "1"
        : this.establecimientoActual.Web;
      const {
        RazonSocial,
        Nombre,
        SectorActividad,
        Descripcion,
        IAE,
        CIF,
        Direccion,
        CP,
        PersonaContacto,
        Cargo,
        EMail,
        VerifyEMail,
        Telefono,
        IBAN,
        UrlImagen,
        UrlDni,
        UrlCertificado,
        UrlIAE,
        checkbox,
      } = data;

      const Peticion = `<Peticion IdOrigen="${IdOrigenRef}" Slug="${slug}" Bonos="${bonosRef}" CIF="${CIF}" IdFormulario="${IdRef}" SectoresActividad="${sectoresRef}" CampanyasBonos="${campanasRef}" IAE="${iaeRef}" IdPaisINE="0" IdPoblacionINE="0" IdProvinciaINE="0" IdBarrio="${idBarrioRef}" Nombre="${Nombre}" RazonSocial="${RazonSocial}" Descripcion="${Descripcion}" SectorActividad ="${sectoresRef}" NumeroEmpleados="1" PersonaContacto="${PersonaContacto}" Cargo="${Cargo}" Contacto="1" Telefono="${Telefono}" EMail="${EMail}" Web="${Web}" NombreAsociacion="1" Direccion = "${Direccion}" CP = "${CP}" Provincia = "BIZKAIA" Poblacion = "Bilbao" Pais = "España" IBAN = "${IBAN}" IdGoogle = "1" Lat = "1" Lng = "1" DireccionGoogle = "1" UrlImagen = "${UrlImagen}" UrlDni="1" UrlCertificado="${UrlCertificado}" UrlIAE="${UrlIAE}" />`;

      const llamada = await this.$store.dispatch("insertarCompleto", Peticion);
      if (llamada.hasOwnProperty("data")) {
        const establecimiento = llamada.data.ESTABLECIMIENTOS_INSERTAR_V2;
        if (establecimiento.Respuesta == "OK") {
          this.$toast.info(this.$t("ALTA COMPLETADA CON ÉXITO"));
          const idEstablecimiento = establecimiento.Peticiones.Peticion.Retorno;
          this.$store.commit("idEstablecimientoActual", idEstablecimiento);
          this.$store.commit("slug", `${idEstablecimiento}-${slug}`);
          this.$router.push(`/${this.$i18n.locale}/contenido/final/`);
          this.$store.dispatch("resetFormulario");
        } else {
          this.$toast.warning(this.$t("ERROR DE DATOS O DE ENVÍO"));
        }
      } else {
        this.$toast.error(this.$t("ERROR EN EL ENVÍO, INTÉNTELO MÁS TARDE"));
      }
      console.log("llamada", llamada, this.establecimientoActual);
    },
    accionCambio(valor) {
      this.$nextTick(() => {
        this.establecimientoActual[valor] = this[valor].map((e) => e.value);
        // console.log('cambio', datos, this.establecimientoActual[valor] )

        // const campo = valor.name

        console.log(
          "valor sss",
          valor,
          this[valor],
          "establ",
          this.establecimientoActual[valor],
          "formulario",
          this.establecimientoActual
        );
      });
    },
    async accion() {
      const id = "180";

      return await this.$store.dispatch("asignarSectores", id);
      await this.$store.dispatch("asignarIAE", id);
      await this.$store.dispatch("asignarBonos", id);
    },
    async checkDireccion(sitio) {
      const google = await gmapsInit();
      const map = this.$refs.mapa;
      var service;

      var query = sitio.Nombre + " " + sitio.Direccion;

      var request = {
        query,
        fields: [
          "name",
          "geometry",
          "formatted_address",
          "id",
          "place_id",
          "icon",
          "types",
          "photos",
          "business_status",
        ],
      };
      /// console.log('aqui 22',  query, google)
      service = new google.maps.places.PlacesService(map);
      service.findPlaceFromQuery(request, (results, status) => {
        /// console.log('dentro', results, status, google)
        if (status == "OK") {
          const actual = results[0];
          this.establecimientosGoogle = results;
          this.establecimientoActual.IdGoogle = actual.place_id;
          this.establecimientoActual.DireccionGoogle = actual.formatted_address;
          this.establecimientoActual.Lat = String(
            actual.geometry.location.lat()
          );
          this.establecimientoActual.Lng = String(
            actual.geometry.location.lng()
          );

          var latLng = new google.maps.LatLng(
            actual.geometry.location.lat(),
            actual.geometry.location.lng()
          );
          var mapOptions = {
            zoom: 19,
            center: latLng,
          };
          const map2 = new google.maps.Map(this.$refs.mapa, mapOptions);
          var marker = new google.maps.Marker({
            position: latLng,
            map: map2,
            title: this.establecimientoActual.Nombre,
          });
        } else {
          /// console.log('sin resultados')
        }
      });
    },
    log(valor) {
      // console.log('varl', valor)
      // this.nuevaImagen = valor
    },
    IBANCorrecto(valor) {
      return fn_ValidateIBAN(valor);
    },
    verLog(valor) {
      // cl*("ver log formulario", valor, "ver Datos", this.validador);
    },
    cerrarVentana(valor) {
      // cl*("cerrar ventana", valor);
      this[valor] = false;
    },
    imagenActual(valor) {
      return this;
    },
    async onSubmit({ target }) {
      const form = new FormData(target);
      const data = Object.fromEntries(form);
      // this.establecimientoActual.UrlImagen = this.UrlImagen
      // this.establecimientoActual.UrlDni = this.UrlDni
      // this.establecimientoActual.UrlCertificado = this.UrlCertificado
      // this.establecimientoActual.UrlIAE = this.UrlIAE
      // this.establecimientoActual.Contacto = JSON.stringify(this.camposExtra);

      this.establecimientoActual.Contacto = "1";
      this.establecimientoActual.multi = "1";
      this.establecimientoActual.IdFormulario = this.Id;
      const objeto = this.establecimientoActual;

      Object.keys(objeto).forEach((campo) => {
        if (!Array.isArray(objeto[campo])) {
          objeto[campo] = objeto[campo]
            .replace(/&/g, "&amp;")
            .replace(/>/g, "&gt;")
            .replace(/</g, "&lt;")
            .replace(/"/g, "&quot;");
        } else {
          /// console.log('mirame', objeto[campo])
        }
      });
      // this.establecimientoActual.Nombre = this.establecimientoActual.Nombre.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
      Object.keys(objeto).forEach(function (e) {
        if (objeto[e] == "") objeto[e] = "1";
      });
      const gestionAlta = await this.$store.dispatch("gestionAlta", objeto);
      objeto.multi = {
        IAES: this.IAE,
        SectorActividad: this.SectorActividad,
        TipoBono: this.TipoBono,
      };
      console.log("objeto", objeto, this.establecimientoActual.multi);
      this.$store.commit("establecimientoActual", objeto);

      // const insertarEstablecimientos = await this.$store.dispatch("alta", objeto)
      this.$store.dispatch("alta", objeto).then((res) => {
        if (res.hasOwnProperty("ESTABLECIMIENTOS_INSERTAR")) {
          const respuesta = res.ESTABLECIMIENTOS_INSERTAR.Respuesta;
          if (respuesta == "OK") {
            this.$router.push(`/${this.$i18n.locale}/contenido/final`);
            this.$store.dispatch("resetFormulario");
          } else {
            this.mensaje = "ERROR en el envio";
          }
        } else {
          /// console.log(res)
          this.mensaje = "Existen campos con datos incorrectos";
        }
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.vts-input {
  margin-bottom: 1rem;
}
.obligatorio .vts-input__text:after {
  content: "*";
  speak: none;
  color: red;
}
.vts-input__input {
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 8px;
  overflow-x: auto;
}
.condiciones .vts-input--checkbox label {
  display: flex;
}

.vts-input--checkbox .vts-input__input {
  width: 20px;
}
.vts-input--error .vts-input__input {
  border-color: red;
}
.vts-input__description small {
  color: red;
}

.vts-form input {
  width: 100%;
}
.vts-form input,
.vts-form button {
  border-radius: 5px;
  padding: 0.5rem;
}

.vts-form input {
  border: 1px solid #e2e8f0;
}

.vts-form button {
  border: 0;
}

/* .vts-form:not(.vts-form--invalid) button {
  color: #fff;
  background: seagreen;
} */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* margin: 0; */
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

